import L from "../../libs/leaflet";
import { createRoot } from "react-dom/client";
import { FaSearch } from "react-icons/fa";

export function buildMapSearchInput(searchConfig) {
    const {
        id,
        placeholder = "Buscar...",
        title = "Buscar",
        type = "text",
        onSearch,
        icon = <FaSearch size={18} />,
    } = searchConfig || {};

    return L.Control.extend({
        options: { position: "topleft" },

        onAdd(map) {
            const container = L.DomUtil.create(
                "div",
                "leaflet-control search-control",
            );

            const inputField = L.DomUtil.create("input", "search-input", container);
            inputField.type = type;
            inputField.placeholder = placeholder;

            const button = L.DomUtil.create("a", "search-button", container);
            button.title = title;
            button.href = "#";
            button.type = "button";

            const root = createRoot(button);
            root.render(icon);

            button.onclick = (e) => {
                e.preventDefault();
                const query = inputField.value.trim();
                if (query) onSearch?.(query);
            };

            L.DomEvent.disableClickPropagation(container);
            L.DomEvent.stopPropagation(container);

            // Responsive positioning (tu lógica)
            const adjustPosition = () => {
                const mapWidth = map.getSize().x;
                const topLeftControls = map
                    .getContainer()
                    .querySelector(".leaflet-top.leaflet-left");

                if (mapWidth < 480) {
                    container.classList.add("mobile-search");
                    topLeftControls?.classList.add("mobile-offset");
                } else {
                    container.classList.remove("mobile-search");
                    topLeftControls?.classList.remove("mobile-offset");

                    const controlWidth = container.offsetWidth;
                    container.style.left = `${(mapWidth - controlWidth) / 2}px`;
                }
            };

            adjustPosition();
            map.on("resize", adjustPosition);

            container.dataset.controlId = id ?? "default-search";
            return container;
        },
    });
}
